export default {"src":"/_next/static/media/desktop-empty-state.77f45cd8.svg","height":140,"width":200,"blurWidth":0,"blurHeight":0};